const faqData = [
  {
    question: 'What are these group classes?',
    answer: [
      "Group classes are proper digital tuition, in a focused learning environment for you, and only a few others. You'll always be live with the teacher, sharing a virtual learning space, in real time.",
    ],
  },
  {
    question: 'How do I join this class?',
    answer: [
      "It's simple! Once you register for a group class, you'll be given an option to select a batch. Once you complete the payment, you're in!",
    ],
  },
  {
    question: 'What batch should I pick?',
    answer: [
      "We have batches based on the artist's availability. Pick any batch that suits your timing, and the experience will be the same across all batches.\n",
    ],
  },
  {
    question: 'How do I attend the classes?',
    answer: [
      "You'll always have access to the group class from within the 'My Courses' section on your Dashboard. You can also come online on livdemy.com at your chosen batch time, and head to the class page! You can get to the Course Dashboard from there.",
    ],
  },
  {
    question: 'What happens when I miss a class?',
    answer: [
      "We'll be recording the content for you in case you are unable to make it to the class. If you miss out on anything, you'll have access to the recording in your Course Dashboard. These class recordings are available upto 6 months from the day the class is over.",
    ],
  },
  {
    question: 'Do I get study material?',
    answer: [
      'Your teacher might provide you study material to go along with particular lessons. On your class page, you have a lesson plan which would have the files you need to download.',
    ],
  },
]

export default faqData
